import { cn } from '@/src/infrastructure/lib/utils';
import type { ReconciliationFindingRow } from '../types';

export function isFindingStale(row: ReconciliationFindingRow): boolean {
  if (row.resolvedAt) return false;
  const detectedMs = new Date(row.detectedAt).getTime();
  const nowMs = Date.now();
  const fourHoursMs = 4 * 60 * 60 * 1000;
  return nowMs - detectedMs > fourHoursMs;
}

export function FindingStatusBadge({ row }: { row: ReconciliationFindingRow }) {
  if (row.resolvedAt) {
    if (row.autoResolved) {
      return (
        <span
          data-testid="finding-status-badge"
          className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border bg-slate-500/10 text-slate-300 border-slate-500/30"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-slate-400" />
          Auto-Replayed
        </span>
      );
    }
    return (
      <span
        data-testid="finding-status-badge"
        className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border bg-emerald-500/10 text-emerald-400 border-emerald-500/30"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
        Resolved
      </span>
    );
  }

  if (isFindingStale(row)) {
    return (
      <span
        data-testid="finding-status-badge"
        className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold border bg-rose-500/10 text-rose-400 border-rose-500/40 animate-pulse"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-rose-400" />
        Stale Alert (&gt;4h)
      </span>
    );
  }

  return (
    <span
      data-testid="finding-status-badge"
      className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border bg-amber-500/10 text-amber-400 border-amber-500/30"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-amber-400" />
      Open
    </span>
  );
}
